// node modules
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// app modules: components
import ContentTile from 'components/ContentTile';

// app modules: props
import AuthorsProps from 'components/Authors/AuthorsProps';
import RecipeImageProps from 'components/RecipeImage/RecipeImageProps';

class SearchRecipeItem extends Component {
  static propTypes = {
    item: PropTypes.shape({
      authors: PropTypes.arrayOf(PropTypes.string),
      authors_: AuthorsProps.authors,
      book_authors: PropTypes.arrayOf(PropTypes.string),
      book_title: PropTypes.string,
      book_signature_: PropTypes.string,
      book_image_name: PropTypes.string,
      book_isbn: PropTypes.string,
      id: PropTypes.string,
      image: RecipeImageProps.graphic,
      title: PropTypes.string,
      star_rating_average: PropTypes.number,
      star_rating_count: PropTypes.number,
    }).isRequired,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  render() {
    const { item, onClick } = this.props;
    const itemAuthor = item.authors_;

    return (
      <ContentTile
        item={{
          alacarte: item.is_alacarte,
          authors: itemAuthor,
          book: {
            isbn: item.book_isbn,
            image_name: item.book_image_name,
            image_permission: true,
            title: item.book_title,
            signature_: item.book_signature_,
            authors: item.book_authors,
          },
          checked: false,
          instagram_thumbnail_url:
            item.image && item.image.type === 'instagram' ? item.image.src : null,
          id: item.id,
          title: item.title,
          // The search results contain an empty object (type=unknown, src=null) for absent images
          // Thats necessary for compatibility with old clients who expect that
          primary_image: item.image?.src ? item.image : null,
          ratings: {
            average: item.star_rating_average,
            count: item.star_rating_count || 0,
          },
        }}
        onClick={onClick}
        referrer="Search"
        section="Search"
      />
    );
  }
}

export default SearchRecipeItem;
